import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";

import {
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead
} from "../../styles/styledTable";

import MasterRefillingsItem from "./MasterRefillingsItem";

const MasterRefillingsList = ({ t, refillings, setNotification }) => {

  if (!refillings) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (refillings.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1280"
        size="14"
        className="master-refilling-table"
      >
        <StyledTableHead
          scroll="auto"
          col="6"
          className="master-refilling-table__head"
        >
          <div>
            {t("table.amount")}
          </div>
          <div>
            {t("table.service")}
          </div>
          <div>
            {t("table.type")}
          </div>
          <div>
            {t("table.user")}
          </div>
          <div>
            {t("table.createdAt")}
          </div>
          <div>
            ID
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {refillings && refillings.map((value, key) => (
            <MasterRefillingsItem
              key={key}
              t={t}
              value={value}
              setNotification={setNotification}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default MasterRefillingsList;